import { render, staticRenderFns } from "./multi-select.html?vue&type=template&id=70950447&scoped=true&"
import script from "./multi-select.js?vue&type=script&lang=js&"
export * from "./multi-select.js?vue&type=script&lang=js&"
import style0 from "./multi-select.scss?vue&type=style&index=0&id=70950447&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70950447",
  null
  
)

export default component.exports